import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
import { CardCategory } from "../../../../molecules/ArticleFeaturedCard/components/ArticleFeaturedCard";
import shade from "polished/lib/color/shade";
import { CarouselProgressBar } from "../../../../components/Carousel";
export const lionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}
  --color-primary-dark: ${shade(0.4, chroma.palette.primary)};

  .header h2 {
    ${chroma.typography.display3};
  }

  ${CardCategory} {
    color: var(--color-primary-dark) !important;
  }

  ${CarouselProgressBar} {
    .indicator {
      background-color: var(--color-primary-dark) !important;
    }
  }
`;
//# sourceMappingURL=index.js.map